<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        编辑分类广告
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">编辑</div>
      </div>
      <div class="table">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          style="padding-top:30px; margin: 0 auto"
        >
          <el-form-item label="商品分类:">
            <template>
              <el-select
                style="width:300px"
                multiple
                filterable
                :multiple-limit="8"
                allow-create
                default-first-option
                v-model="value1"
                :data="options1"
                placeholder="商品分类"
              >
                <el-option
                  v-for="item1 in options1"
                  :key="item1.value1"
                  :label="item1.title"
                  :value="item1.title"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item label="上传图片1:">
            <el-upload
              action
              list-type="picture-card"
              :auto-upload="false"
              :limit="1"
              :on-change="getImage"
              :file-list="img1List"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传图片2:">
            <el-upload
              action
              list-type="picture-card"
              :auto-upload="false"
              :limit="1"
              :on-change="getImage1"
              :file-list="img2List"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="图片地址1:">
            <el-input v-model="link1" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="图片地址2:">
            <el-input v-model="link2" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="button" @click="submit()">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
            serve: this.$store.state.serve,
      options1: [],
      value1: [],
      labelPosition: "right",
      username: "",
      token: "",
      id: this.$route.params.id,
      link1: "",
      link2: "",
      img1: "",
      img2: "",
      img2List: [],
      img1List: []
      // img1: [{
      //    url:serve+'/category_ad/1category_ad1.jpg'
      // }]
    };
  },
  created() {
    //获取数据
    //获取下拉框
    this.$store.state.leftTitle = "分类广告";
    this.$store.state.topActiveId = 5;
    this.xiala();
    this.geting();
  },
  methods: {
    xiala() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/get_brand_name", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            for (var key in res.data.data) {
              this.options1.push({
                title: res.data.data[key]
              });
            }
          }
        });
    },
    geting() {
      this.axios
        .get(this.serve+"/admin/category_ad_detail", {
          params: {
            username: this.username,
            token: this.token,
            category_id: this.id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            if(json.brand_list != ''){
              this.value1 = json.brand_list.split(";");
            }
            
            this.link1 = json.link1;
            this.link2 = json.link2;
            if(json.image1 != ''){
              this.img1List.push({
              url: this.serve+"" + json.image1
            });
            }
            if(json.image2 != ''){
              this.img2List.push({
              url: this.serve+"" + json.image2
            });
            }
            
          }
        });
    },

    getImage(file, fileList) {
      this.img1 = file.raw;
    },
    getImage1(file, fileList) {
      this.img2 = file.raw;
    },
    submit() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var value2 = this.value1.join(";");
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("brand_list", value2);
      formData.append("category_id", this.id);
      formData.append("image1", this.img1);
      formData.append("image2", this.img2);
      formData.append("link1", this.link1);
      formData.append("link2", this.link2);
      this.axios
        .post(
          this.serve+"/admin/category_ad_edit",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: res.data.msg
            });
            this.$router.push({
              path: "/admin/c_classified"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }else if (res.data.status == "error") {
            this.$message.error("操作失败");
          }
        });
    }
  }
};
</script>
<style lang="scss">
.quillWrapper {
  padding: 0;
  margin: 0;
  width: 700px;
  .ql-toolbar {
    display: flex;
    align-items: center;

    justify-content: space-between;
    .ql-formats {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 !important;
      margin: 0 !important ;
      .ql-picker {
        .ql-picker-label {
          display: flex;
          align-items: center;
        }
      }
      .ql-header {
        .ql-picker-label {
          display: flex;
        }
      }
    }
  }
}

.editGallery {
  #tetx {
    width: 330px;
    height: 200px;
  }
  background: #f5f5f5;
  color: #333;
  height: 1000px;
  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 190px;
    height: 44px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
